import { JsEnv } from '../../../core/models/js_env';
import { ItemRequest } from '../models/item_request';
import { ItemRequestJsEnv } from '../models/item_request_js_env'
import { TypedEvent } from '../../../core/typed_event';
import { LenCountAction } from '../actions/lencount_action';
import { ItemRequestSubmitAction } from '../actions/item_request_submit_action';

export class ItemRequestAction {
  static readonly UPDATE_EVENT = new TypedEvent<ItemRequestJsEnv>();
  private static state: ItemRequest;

  static async init(env: JsEnv, containerClass: any) {
    this.state = new ItemRequest(env.PAGE);
    return new containerClass(this.state.getModel());
  }

  static openModal() {
    this.state.setIsSendSuccess(false);
    this.state.setIsSendFailed(false);
    LenCountAction.reset();
    ItemRequestSubmitAction.UPDATE_EVENT.trigger(this.state.getModel());
  }
}
